// returns true if click is off jam and on the page
// goal is to allow people to interact with the page and also with jam

export default function clickIsNotOnJamElement(e: MouseEvent) {
	// clickX/Y relative to viewport
	// https://stackoverflow.com/questions/6073505/what-is-the-difference-between-screenx-y-clientx-y-and-pagex-y
	const { clientX, clientY } = e

	const elementsToCheckIfClicked: Element[] = [
		// query selector get all open comments
		...Array.from(document.querySelectorAll(".jam--editor")),
		// get all previews
		...Array.from(document.querySelectorAll(".jam--preview")),
		// get all open threads
		...Array.from(document.querySelectorAll(".jam--thread-header-container")),
		...Array.from(document.querySelectorAll(".jam--thread-container")),
		// get the jam button
		...Array.from(document.querySelectorAll(".jam--main-jam-button")),
	]

	if (elementsToCheckIfClicked.length === 0) {
		return true // TODO
	}

	for (let element of elementsToCheckIfClicked) {
		// if (element === null || element === undefined) {
		//   return;
		// }

		const elementPosition = element.getBoundingClientRect()
		const checkX =
			clientX > elementPosition.left && clientX < elementPosition.right
		const checkY =
			clientY > elementPosition.top && clientY < elementPosition.bottom

		if (checkX && checkY) {
			return false
		}

		// for testing - put a box around each elemement
		// const el = document.createElement('div')
		// el.style.position = 'absolute'
		// el.style.zIndex = 2000000
		// el.style.background = 'blue'
		// el.style.opacity = 0.1
		// el.style.top = `${elementPosition.y}px`
		// el.style.height = `${elementPosition.height}px`
		// el.style.left = `${elementPosition.x}px`
		// el.style.width = `${elementPosition.width}px`
		// document.body.appendChild(el)
	}

	return true
}
